import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import QuestionsForms from "schedule-v2/commonPages/Components/QuestionCards/QuestionsForm";
import { isMultiQuestionType } from "./utils/QuestionsPage.utils";

export default function QuestionsFormModal(props) {
  // If Multi Type Question then we will not allow user to edit these custom Questions
  const isQuestionMultiType = isMultiQuestionType(props?.record?.type);

  return (
    <ExlyModal
      title={props.title}
      open={props.isOpen}
      onPrimaryBtnClick={props.handleSubmit}
      primaryBtnProps={{ disabled: isQuestionMultiType }}
      onClose={props.closeModal}
      primaryBtnText={props.ctaText}
      modal_props={{
        modalPaperClassName: "tw-w-[500px]",
      }}
    >
      <QuestionsForms record={props?.record} />
    </ExlyModal>
  );
}
